import { Flex, FlexProps, Icon, smBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  getMandatoryExcessComparison,
  hasUniqueExcesses,
  Quote,
} from '../../../../domain'
import { ExcessData } from '../../../../hooks/adjustments/policy'
import { useExcesses } from '../../../../hooks/excess'
import { VoluntaryExcess } from '../VoluntaryExcess'
import { MainExcessBreakdown } from './MainExcessBreakdown'
import { MainExcessSummary } from './MainExcessSummary'

export interface ExcessProps extends FlexProps {
  currentQuote: Quote
  previousQuote?: Quote
  onChange?: (data: ExcessData) => void
}

export const MainExcesses: React.FC<ExcessProps> = ({
  currentQuote,
  previousQuote,
  onChange,
  ...props
}) => {
  const { main: currentExcesses, voluntary } = useExcesses(currentQuote)
  const { main: previousExcesses } = useExcesses(previousQuote)

  const excessComparisons = getMandatoryExcessComparison(
    previousExcesses,
    currentExcesses,
  )

  const hasMainExcesses = Boolean(excessComparisons.length)
  const hasBreakdown = hasUniqueExcesses(excessComparisons)
  const hasVoluntaryExcesses = Boolean(voluntary?.length)

  return hasMainExcesses ? (
    <Flex
      flexDirection={hasBreakdown ? 'column' : ['column', 'column', 'row']}
      alignItems='stretch'
      {...props}
    >
      {hasBreakdown ? (
        <MainExcessBreakdown excessComparisons={excessComparisons} />
      ) : (
        <MainExcessSummary excessComparison={excessComparisons[0]} />
      )}
      {hasVoluntaryExcesses && [
        <Divider key='divider' />,
        <VoluntaryExcess
          key='voluntaryExcess'
          quote={currentQuote}
          onChange={onChange}
        />,
      ]}
    </Flex>
  ) : hasVoluntaryExcesses ? (
    <VoluntaryExcess quote={currentQuote} onChange={onChange} />
  ) : null
}

const Divider: FunctionComponent = () => (
  <Flex justifyContent='center' alignItems='center'>
    <Icon m={smBumps} icon='plus' size='small' />
  </Flex>
)
